import { useEffect } from 'react'
import FieldWrapper from '../../Form/FieldWrapper/FieldWrapper'
import ReactSelect, { createFilter } from 'react-select'
import { Flex, FormLabel } from '@chakra-ui/react'

const UncontrolledSelect = ({
  label = '',
  options = [],
  isMulti = false,
  disabled = false,
  isRequired = true,
  canHighLight = true,
  width,
  value,
  isClearable = true,
  onChange = () => {},
}) => {
  const selectedOption = options.filter((option) =>
    isMulti && Array.isArray(value) ? value.includes(option?.value) : option?.value === value
  )

  return (
    <Flex gap="2" alignItems={'center'}>
      {label !== '' && <FormLabel>{label}</FormLabel>}
      <ReactSelect
        isMulti={isMulti}
        styles={{
          container: (base) => ({
            ...base,
            ...(width ? { width } : {}),
          }),
          control: (base, { isDisabled }) => {
            let bgColor = 'white'
            if (value === '' && isRequired) {
              bgColor = 'yellow'
            }
            if (isDisabled) {
              bgColor = 'hsl(0, 0%, 95%)'
            }
            return {
              ...base,
              backgroundColor: bgColor,
              borderColor: '#E2E8F0',
            }
          },
          singleValue: (base) => ({
            ...base,
            color: 'hsl(0, 0%, 50%)',
          }),
          multiValueRemove: (base, state) => {
            return state.isDisabled ? { ...base, display: 'none' } : base
          },
        }}
        menuPosition="fixed"
        menuPlacement={'auto'}
        filterOption={createFilter({ ignoreAccents: false })}
        value={selectedOption}
        options={options}
        onChange={(newValue) => {
          // console.log('newValue', newValue)
          onChange(newValue)
          // if (Array.isArray(newValue)) {
          //   const selectedValues = newValue.map((option) => option?.value ?? '').filter((opt) => opt !== '')
          //   onChange(selectedValues)
          // } else {
          //   onChange(newValue?.value ?? '')
          // }
        }}
        isDisabled={disabled}
        isClearable={isClearable}
      ></ReactSelect>
    </Flex>
  )
}

export default UncontrolledSelect
